import { render, staticRenderFns } from "./PersonalCenterMain.vue?vue&type=template&id=563e4299&scoped=true&"
import script from "./PersonalCenterMain.vue?vue&type=script&lang=js&"
export * from "./PersonalCenterMain.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCenterMain.vue?vue&type=style&index=0&id=563e4299&prod&lang=less&"
import style1 from "./PersonalCenterMain.vue?vue&type=style&index=1&id=563e4299&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563e4299",
  null
  
)

export default component.exports